"use client";

// src/primitives/contentPart/ContentPartText.tsx
import {
  forwardRef
} from "react";
import { useContentPartText } from "./useContentPartText.js";
import { useSmooth } from "../../utils/smooth/useSmooth.js";
import { jsx } from "react/jsx-runtime";
var ContentPartPrimitiveText = forwardRef(({ smooth = true, component: Component = "span", ...rest }, forwardedRef) => {
  const { text, status } = useSmooth(useContentPartText(), smooth);
  return /* @__PURE__ */ jsx(Component, { "data-status": status.type, ...rest, ref: forwardedRef, children: text });
});
ContentPartPrimitiveText.displayName = "ContentPartPrimitive.Text";
export {
  ContentPartPrimitiveText
};
//# sourceMappingURL=ContentPartText.js.map